import { render, staticRenderFns } from "./OrgPruductManager.vue?vue&type=template&id=67aacb13&scoped=true"
import script from "./OrgPruductManager.vue?vue&type=script&lang=js"
export * from "./OrgPruductManager.vue?vue&type=script&lang=js"
import style0 from "./OrgPruductManager.vue?vue&type=style&index=0&id=67aacb13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aacb13",
  null
  
)

export default component.exports